import {Component, OnInit, ViewChild} from '@angular/core';
import {Option} from '../../../Models/Option';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {LanguageModel} from '../../../../translation/translation.models';
import {Helper} from '../../../../helpers/helper.service';
import {LanguageService} from '../../../../translation/Services/language.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {OptionService} from '../../../Services/option.service';
import {TranslationFormlyService, TranslationIdMap} from '../../../Services/translation.formly.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-manage-option',
  templateUrl: './manage-option.component.html',
  styleUrls: ['./manage-option.component.scss']
})
export class ManageOptionComponent implements OnInit {

  public classicBox;
  public lastValue = {option: new Option()};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public translations = [];
  public optionId: number;
  public isEdit = false;
  options: FormlyFormOptions = {};
  public languageMap = {};
  public languages: LanguageModel[] = [];
  private translationFields = ['name', 'description'];
  // D14/D16/D17: parallel {field: {locale: id}} lookup, see TranslationFormlyService.
  private translationIds: TranslationIdMap = {};
  @ViewChild('classicForm', {static: false}) child;
  public selectedValues: any[];

  constructor(
    public helper: Helper,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private optionService: OptionService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.languageService.list().subscribe(lang_resp => {
      this.languages = lang_resp.languages;
      this.languages.forEach(lang => {
        this.languageMap[lang.locale] = lang.locale;
      });

      this.route.params.subscribe(params => {
        new Promise((resolve, reject) => {
          if (Helper.isDefined(params['id'])) {
            this.optionId = params['id'];
            this.isEdit = true;
            this.optionService.getOptionItem(this.optionId).subscribe(resp => {
              resolve(resp);
            });
          } else {
            resolve(new Option());
          }
        }).then(option => {
          this.lastValue = {option: (<Option>option)};
        }).then(() => {
          this.translationIds = TranslationFormlyService.buildTranslationIdMap(this.lastValue.option.translations);
          this.lastValue.option.translations = TranslationFormlyService.prepareTranslationFields(this.translationFields,
            this.lastValue.option.translations, this.languages);
          if (this.lastValue.option.required) {
            // I do this because required input must be in translations name field group in UI
            this.lastValue.option.translations.required = this.lastValue.option.required;
          }
        }).then(() => {
          this.classicBox = <FormlyFieldConfig>[
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.option.show.option_name') + '</strong></div><hr>',
            },
          ];
          this.classicBox = <FormlyFieldConfig>[];
          Object.keys(this.lastValue.option.translations).forEach((field) => {
            const row = {
              fieldGroupClassName: 'row',
              key: 'option.translations',
              fieldGroup: []
            };
            this.classicBox.push(
              {
                className: 'section-label',
                template: '<div><strong>' + this.translate.instant('admin.option.show.' + field + '_name') + '</strong></div><hr>',
              }
            );
            Object.entries(this.lastValue.option.translations[field]).forEach((t) => {
              row.fieldGroup.push(
                {
                  className: 'col-6 ',
                  type: 'input',
                  key: field + '[' + t[0] + ']',
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.' + field) + ' (' + this.languageMap[t[0]] + ')',
                    required:
                      (field !== 'description' ? true : false),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, fieldItem: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                        {limit: fieldItem.templateOptions.maxLength})
                    },
                  },
                }
              );
            });
            this.classicBox.push(row);
          });

          this.classicBox.push(
            {
              fieldGroupClassName: 'row',
              key: 'option',
              fieldGroup: [
                {
                  className: 'col-3',
                  type: 'checkbox',
                  key: 'required',
                  templateOptions: {
                    label: this.translate.instant('admin.backoffice.option.add_option.is_required'),
                  },
                },
                {
                  className: 'col-3',
                  type: 'checkbox',
                  key: 'typePerProduct',
                  defaultValue: this.lastValue.option.type === Option.OPTION_TYPE_PER_PRODUCT,
                  templateOptions: {
                    label: this.translate.instant('admin.backoffice.option.add_option.type_per_product'),
                    maxLength: environment.maxStringLength,
                  },
                }
              ]
            }
          )

          this.classicBox.push(
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.option.show.other') + '</strong></div><hr />',
            },
            // system desc
            {
              fieldGroupClassName: 'row',
              key: 'option',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'systemDescription',
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.system_description'),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      maxlength: (error, fieldItem: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                        {limit: fieldItem.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'code',
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.code'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validators: {
                    code: {
                      expression: (c) =>  !(/[(:)*|(\(|\))*|,*]+/i.test(c.value)),
                      message: (error, field: FormlyFieldConfig) => this.translate.instant('validators.option_code'),
                    },
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      maxlength: (error, fieldItem: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                        {limit: fieldItem.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'factoryCode',
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.factory_code'),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      maxlength: (error, fieldItem: FormlyFieldConfig) => this.translate.instant('validators.max_message',
                        {limit: fieldItem.templateOptions.maxLength})
                    },
                  },
                },
                // status
                {
                  key: 'status',
                  type: 'ng-select',
                  className: 'col-3',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.status'),
                    required: true,
                    options: [
                      {label: this.translate.instant('global.active'), value: true},
                      {label: this.translate.instant('global.inactive'), value: false},
                    ],
                  },
                },
                {
                  key: 'exportColumn',
                  type: 'ng-select',
                  className: 'col-3',
                  defaultValue: null,
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.export_column'),
                    required: false,
                    options: [
                      {label: this.translate.instant('doctrine.option.no_export_column'), value: null},
                      {label: 'B', value: 'B'},
                      {label: 'D', value: 'D'},
                      {label: 'E', value: 'E'},
                      {label: 'G', value: 'G'},
                      {label: 'J', value: 'J'},
                      {label: 'K', value: 'K'},
                      {label: 'L', value: 'L'},
                      {label: 'M', value: 'M'},
                    ],
                  },
                },
                {
                  key: 'carpetRole',
                  type: 'ng-select',
                  className: 'col-3',
                  defaultValue: null,
                  templateOptions: {
                    label: this.translate.instant('doctrine.option.carpet_role'),
                    required: false,
                    options: [
                      {label: this.translate.instant('doctrine.option.no_carpet_role'), value: null},
                      {label: this.translate.instant('doctrine.option.carpet_role_shape'), value: Option.CARPET_ROLE_SHAPE},
                      {label: this.translate.instant('doctrine.option.carpet_role_finishing'), value: Option.CARPET_ROLE_FINISHING},
                      {label: this.translate.instant('doctrine.option.carpet_role_colour'), value: Option.CARPET_ROLE_COLOUR},
                    ],
                  },
                },
              ],
            }
          );
        });
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const option = JSON.parse(JSON.stringify(this.child.onFormSubmit()));
      // I do this because required input must be in translations name field group in UI
      delete option.option.id;
      option.option.translations = TranslationFormlyService.reorganizeTranslations(this.translationFields,
        option.option.translations, this.translationIds);
      this.optionService.manageOption(option, this.isEdit, this.optionId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/option/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/option/overview');
    }
  }


}
